module.exports = __webpack_public_path__ + "img/dj.e22311fa.png";